import { defineMessages } from 'react-intl';

export default defineMessages({
  connectionMode: 'Connection mode',
  normal: 'Normal',
  light: 'Light',
});
